module.exports = __webpack_public_path__ + "static/media/PreludeCMajor.3e2610fe.md";